import React, { useState } from "react";
import { Tabs } from "@mantine/core";
import ServicesMenuTab from "./ServicesMenuTab";
import AdjustmentFormsTab from "./AdjustmentFormsTab";
import usePermissions from "../../hooks/usePermissions";

function ServicesManagement({ onSubmit }) {
  const [activeTab, setActiveTab] = useState("services");
  const perms = usePermissions();
  const servicesPerms = perms?.settingsServices;

  return (
    <Tabs value={activeTab} onChange={setActiveTab}>
      <Tabs.List>
        <Tabs.Tab value="services">Services Menu</Tabs.Tab>
        {servicesPerms?.canViewAdjustmentForms !== false && (
          <Tabs.Tab value="adjustments">Adjustment Forms</Tabs.Tab>
        )}
      </Tabs.List>

      <Tabs.Panel value="services">
        <ServicesMenuTab
          onSubmit={onSubmit}
          canCRUD={servicesPerms?.canManageServices !== false}
        />
      </Tabs.Panel>

      {servicesPerms?.canViewAdjustmentForms !== false && (
        <Tabs.Panel value="adjustments">
          <AdjustmentFormsTab
            canCRUD={servicesPerms?.canManageAdjustmentForms !== false}
          />
        </Tabs.Panel>
      )}
    </Tabs>
  );
}

export default ServicesManagement;
